import React from "react";
import _ from "lodash";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../ListingContent/ListingFilterSection/ListingFilterSectionComponent";
import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllCertifications,
  getAllCertificationsResponse,
  getAllCertificationsClear,
} from "../../../redux/certificateURL/actions";
import {
  getAllEventsNIIT,
  getEventDetailsNIITClear,
  getAllEventsNIITClear,
} from "../../../redux/events/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  SessionKeys,
  convertTimeInHourAndMin,
  getPriceInfoForEntity,
  PriceInfo,
} from "../../../utils/AppUtils";
import Loader from "../../Loader/Loader";
import CONFIG from "../../../utils/config";
// import EventSliderFilterSection from './EventSliderFilter';
import { Tab, Tabs } from "react-bootstrap";
import EventListingMainSection from "./EventListingMainSection";
import useLogin from "../../../custom-hooks/useLogin";
import EventsCalendar from "../../Calendar/EventsCalendar";

function EventListSection() {
  const dispatch = useDispatch();
  const observer = useRef();
  const navigate = useNavigate();
  const { isLoggedIn } = useLogin();


  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
  }
  const [eventList, setEventList] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const eventsListRes = useSelector(
    (state) => state.certificateURL.certificationsList
  );
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [eventCount, setEventCount] = useState(0);

  const [apiListing, setAPIListing] = useState([]);
  const [listing, setListing] = useState([]);
  const [providerListing, setProviderListing] = useState([]);

  const [key, setKey] = useState("upComingEvents");
  const [pageNum, setPageNum] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(30);  //CONFIG.PAGINATION_PAGE_SIZE
  const [hasNoMore, setHasNoMore] = useState(true);
  const [searchTxt, setSearchTxt] = useState("");
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const providersDataResponse = useSelector(
    (state) => state.provider.providersDataListRes
  );
  const navigateToView = (data) => {
    let paramsReq = {
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
      type: "myEvents", //myEvents
      provider_id: providerId ? providerId : "",
      provider_name: data?.provider_name ? data?.provider_name : "",
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/event-detail?c=${encodedUrl}`;
    // url = url + `&event_code=${data?.event_code}` + `&source=${data.source}`;
    navigate(url);
  };

  const [selectedSort, setSelectedSort] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [sortOption] = useState([
    { value: 1, label: "Name (A to Z)" },
    { value: 2, label: "Name (Z to A)" },
  ]);
  const [filterOption] = useState([
    { value: 1, label: "All" },
    // { value: 2, label: "Available for Purchase" },
    { value: 3, label: "Purchased Events" },
  ]);


  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0)

  const formatDataForProductCard = (certificatList) => {
    let eventArr = [];
    let records = certificatList.records;
    setTotalRecords(certificatList.total_records);
    setEventCount(certificatList.total_records);
    for (let item of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";

      let footerComp = "";

      eventArr.push({
        id: item?.event_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: item?.type,
        productOrigin: item?.source,
        title: item.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description,
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showProviderIcon: false,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToView(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }

    let newLPArr = eventArr;
    // if (pageNum > 1) {
    //   newLPArr = [...apiListing, ...eventArr];
    //   setEventList(newLPArr);
    //   setAPIListing(newLPArr);
    // } else {
      setEventList(eventArr);
      setAPIListing(eventArr);
    // }

    if (certificatList.total_records === newLPArr.length) {
      setHasNoMore(true);
    } else {
      setHasNoMore(false);
    }
  };

  const fetchEvent = (searchStr = "", page = 1, type = "Event") => {
    setIsLoading(true);
    // setEventList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    let moduleValue = type === "Event" ? "getAllCertifications" : "getMyEvents";
    let reqObj = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        : "",
      type: type,
    };
    if (type === "Event") {
      reqObj.page = 1;
      reqObj.search = searchStr;
      reqObj.sort_by = "";
      reqObj.filter = "";
      reqObj.page_size = pageSize;
      reqObj.page = page;
      reqObj.provider_id = providerId ? providerId : "";
    } else if (type === "event") {
      reqObj.search = searchStr;
      reqObj.sort = "asc";
    }
    dispatch(
      getAllCertifications({
        module: moduleValue,
        postData: reqObj,
      })
    );
  };

  useEffect(() => {
    // fetchEvent(searchTxt, pageNum, "event");
  }, [dispatch, searchTxt]); //pageNum,

  const onSearchClicked = (searchText) => {
    const searchStr = searchText;
    setSearchTxt(searchStr);
  };

  useEffect(() => {
    console.log("eventsres", eventsListRes);
    if (!_.isEmpty(eventsListRes) && eventsListRes?.status === "success") {
      setIsLoading(false);
      let eventsListDetail = eventsListRes.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setListing(eventsListDetail.records);
        formatDataForProductCard(eventsListDetail);
        setIsFetching(false);
      } else {
        setEventList([]);
        setListing([]);
        setEventCount(0);
      }
      dispatch(getAllCertificationsClear());
    } else if (eventsListRes?.status === "error") {
      setIsLoading(false);
      setEventList([]);
    }
  }, [eventsListRes]);

  const formattedListing = useMemo(() => {
    if (!_.isEmpty(eventList)) {
      let videoList = _.cloneDeep(eventList);
      videoList = _.filter(videoList, (video) => {
        if (selectedFilter === 2) {
          return video.priceInfo.price > 0 && !video.priceInfo.isPaid;
        } else if (selectedFilter === 3) {
          return video.priceInfo.isPaid;
        } else {
          return video;
        }
      });
      let sortBy = "asc";
      if (selectedSort === 2) {
        sortBy = "desc";
      }
      console.log(selectedSort, sortBy);
      return _.orderBy(videoList, ["view", "title"], ["desc", sortBy]);
    }
    return [];
  }, [eventList, selectedSort, selectedFilter]);

  const onFilterClicked = (filterValue) => {
    // setVideoListing(apiVideoListing.filter(video => {
    //     if (filterValue === 2) {
    //         return video.priceInfo.price > 0 && !video.priceInfo.isPaid
    //     } else if (filterValue === 3) {
    //         return video.priceInfo.isPaid
    //     } else {
    //         return video
    //     }
    // }))
  };

  // const paginateCB = useCallback(
  //   (node) => {
  //     if (isFetching || isLoading) return;

  //     if (observer.current) observer.current.disconnect();

  //     observer.current = new IntersectionObserver((entries) => {
  //       console.log(hasNoMore);
  //       if (entries[0].isIntersecting && !hasNoMore) {
  //         setIsFetching(true);
  //         console.log(
  //           "End of file",
  //           totalRecords,
  //           eventList.length,
  //           pageNum,
  //           isLoading,
  //           isFetching
  //         );
  //         setPageNum((pageNum) => pageNum + 1);
  //         setEventList([...eventList, ...CONFIG.INITIAL_PRODUCT_CARD_DATA]);
  //       }
  //     });

  //     if (node) observer.current.observe(node);
  //     console.log(node);
  //   },
  //   [isLoading, hasNoMore]
  // );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="contsection">
        {false && <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            {false && (
              <button
                className="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Upcoming events
              </button>
            )}
            <Tabs
              underline
              activeKey={key}
              onSelect={(k) => {
                // setIsFetching(true)
                console.log("selectKey: ", k);
                setKey(k);
                setEventList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
                if (k === "upComingEvents") {
                  fetchEvent(searchTxt, pageNum, "Event");
                  setEventCount(0);
                } else {
                  fetchEvent(searchTxt, pageNum, "event");
                  setEventCount(0);
                }
              }}
            >
              <Tab eventKey={"upComingEvents"} title="Upcoming events"></Tab>
              {isLoggedIn && !providerId && (
                <Tab eventKey={"myEvents"} title="My events"></Tab>
              )}
            </Tabs>
          </div>
        </nav>
}
        {false &&<EventListingMainSection
          onSearchClicked={onSearchClicked}
          sortOption={sortOption}
          filterOption={filterOption}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
          setSelectedFilter={setSelectedFilter}
          onFilterClicked={onFilterClicked}
          isFetching={isLoading}
          eventCount={eventCount}
          eventList={eventList}
          formattedListing={formattedListing}
          // refInfo={paginateCB}
        />}
        <EventsCalendar isHome={false} isLearn={true} mySession={true}
        marketingDateRange={null}
        setSelectedSessionFromHome={setSelectedSessionFromHome}
        selectedSessionPos={selectedSessionPos}
        setSelectedSessionPos={setSelectedSessionPos} />
      </div>
    </>
  );
}

export default EventListSection;
